export const version = "units/5.7.0";
//# sourceMappingURL=_version.js.map